<template>
    <div id="core_waybills">
        <div class="ui segment">
            <div style="display: flex; justify-content: space-between;">
                <div> </div>
                <div>
                    <!--
                    * ========================================================================
                    * = 純號碼 無展開 detail filter 時顯示
                    * ========================================================================
                    -->
                    <div v-if="!is_show_filter" style="display: inline;">
                        <div class="ui right labeled left icon input">
                            <i class="search icon"
                                @click="core_waybills_filter()">
                            </i>
                            <input
                                v-if="current_store.quick_filter_key.number == 'operation_number'"
                                @change="$forceUpdate()"
                                @keypress.enter="core_waybills_filter()"
                                v-model="filter.operation.number"
                                type="text"
                            >
                            <input
                                v-else
                                @change="$forceUpdate()"
                                @keypress.enter="core_waybills_filter()"
                                v-model="filter[current_store.quick_filter_key.number]"
                                type="text"
                            >
                            <div class="ui dropdown label no_search" v-dropdown>
                                <div class="text"
                                    v-for="item in current_store.quick_filters.number"
                                    v-if="current_store.quick_filter_key.number == item">
                                    {{ $t('models.attributes.core_waybills.'+item) }}
                                </div>
                                <i class="dropdown icon"></i>
                                <div class="menu">
                                    <div class="item"
                                        v-for="item in current_store.quick_filters.number"
                                        :class="{'selected active': current_store.quick_filter_key.number == item }"
                                        @click="set_quick_filter_key('number', item)"
                                        >
                                        {{ $t('models.attributes.core_waybills.'+item) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--
                    * ========================================================================
                    * = 展開 detail filter 才顯示
                    * ========================================================================
                    -->
                    <div v-if="is_show_filter" style="display: inline;">
                        <div
                            class="ui basic red icon button"
                            @click="$store.dispatch('customer/core_waybills_module/clear_filter',{
                                operation_number: ($route.params.operation_number || null)
                            })">
                            <i class="close icon"></i>
                            {{ $t('ui.general.clear') }}
                        </div>
                    </div>

                    <!--
                    * ========================================================================
                    * = 切換 filter style, 一直顯示
                    * ========================================================================
                    -->
                    <div class="ui icon buttons" style="
                        vertical-align: top;
                        margin-left: 6px;
                        height: 37px;
                        ">
                        <div class="ui button"
                            :data-tooltip="$t('ui.general.advanced')"
                            :class="{active: is_show_filter}"
                            @click="current_store.is_show_filter = !is_show_filter">
                            <i class="icon"
                                :class="{
                                    'minus': is_show_filter,
                                    'bars': !is_show_filter,
                                }"
                            ></i>
                        </div>
                    </div>
                </div>
            </div>

            <transition name="slide-fade" mode="out-in">
                <CustomerDetailFilter v-if="is_show_filter">
                </CustomerDetailFilter>
            </transition>

            <div class="right floated" v-if="is_show_filter">
                <div v-if="current_store.is_can_print_label && !error_message"
                    style="display: inline-block; vertical-align: bottom;">
                    <div v-if="tool_label.numbers" style="display: inline-block;">
                        <div style="display: inline-block; vertical-align: bottom;">
                            <span v-if="$store.state.language == 'en-US'">
                                Total: {{ tool_label.core_waybill_length }}
                            </span>
                            <span v-else>
                                共 {{ tool_label.core_waybill_length }} 件
                            </span>
                        </div>
                        <CoreWaybillsLabelSvg
                            style="text-align: left; display: inline-block; vertical-align: middle;"
                            v-if="tool_label.numbers.length >= 1"
                            :numbers="tool_label.numbers"
                            :printing_type="tool_label.label_name"
                            :authentication_token="token"
                            :scope="'customer'"
                            :is_show_input="false"
                            :is_post_method="true"
                            :node_carrier_name="$store.state.customer.customer.provider_node.carrier_class"
                            >
                        </CoreWaybillsLabelSvg>
                    </div>
                    <div v-else
                        class="field" style="display: inline-block; vertical-align: bottom;">
                        <label>&emsp;</label>
                        <div class="ui button" @click="fetch_core_waybills_pagination_false()">
                            <i class="icon"
                                :class="is_processing_by_core_waybills_pagination_false ? 'circle notch loading' : 'print'"
                            ></i>
                            {{ $t('ui.pages.core_waybills.print_filter_result_labels') }}
                        </div>
                    </div>
                </div>
                <!-- 一般 -->
                <div class="ui button" @click="fetch_core_waybills_csv()">
                    <i class="file icon"></i>
                    {{ $t('ui.pages.core_waybills.export_csv_file') }}
                </div>

                <!-- 清關 -->
                <div class="ui button"
                    @click="fetch_core_waybills_csv('clearance')">
                    <i class="file alternate outline icon"></i>
                    {{ $t('ui.pages.core_waybills.export_clearance_csv_file') }}
                </div>

                <div v-if="converters_group_by_category.export && converters_group_by_category.export.length > 1"
                    class="ui buttons"
                    style="padding-right: 4px;">
                    <div class="ui button" @click="export_core_waybills(current_converter.identity)"
                        :data-tooltip="current_converter.note"
                        :data-position="'bottom left'">
                        <i class="file icon"></i>
                        {{ current_converter.name }}
                    </div>
                    <div class="ui floating dropdown icon button" v-dropdown
                        style="background: #c0c1c2;">
                        <i class="dropdown icon"></i>
                        <div class="menu">
                            <div class="item"
                                v-for="converter in converters_group_by_category.export"
                                @click="current_converter = converter">
                                {{ converter.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="ui button" @click="export_core_waybills()">
                    <i class="file icon"></i>
                    匯出報表
                </div>

                <div
                    class="ui icon blue button"
                    @click="core_waybills_filter()">
                    <i class="search icon"></i>
                    {{ $t('ui.general.search') }}
                </div>
            </div>
            <div class="clear"></div>
        </div>

        <div style="margin: 6px 0;">
            <CoreWaybill
                v-if="is_initialized"
                v-for="core_waybill in core_waybills"
                :key="core_waybill.identity"
                :core_waybill="core_waybill"
                :template="'card'"
                :is_auto_print="false"
                :is_can_update="false"
                :is_can_print_label="false"
                :is_show_change_template_btns="false"
                :cant_update_field_names="[]"
                :scope="'customer'"
                :active_button="{
                    to_detail_route_name: ($route.params.operation_number) ? 'customer_show_core_waybill_operation' :'customer_show_core_waybill'
                }"
                :card="{
                    is_simple_form: false,
                    is_half_style: true,
                    is_vertical: true,
                    is_show_note: true,
                }"
            >
            </CoreWaybill>
        </div>

        <div v-if="!is_initialized || is_processing"
            class="ui segments core_waybill"
            style="text-align:center; height:100px;">
            <div class="ui active inverted dimmer">
                <div class="ui text loader">
                    <h3>
                        <!-- 載入中，請稍等 -->
                        {{ $t('ui.general.initializing') }}
                    </h3>
                </div>
            </div>
        </div>
        <div v-else-if="error_message"
            class="ui red raised segment center aligned">
            <h2>
                {{ error_message }}
            </h2>
        </div>
        <div class="clear"></div>

        <Paginator
            v-if="core_waybills.length"
            :total_pages="current_store.total_pages"
            :current_page="current_store.current_page"
        />
    </div>
</template>

<script>
import CoreWaybillsLabelSvg from "@toolbox/core_waybills_label_svg/main.vue"
import CustomerDetailFilter from "@core_waybills/.components/customer/filter/customer_detail.vue"
import Paginator from '@toolbox/pagination/paginator.vue'
import CoreWaybill from '@toolbox/core_waybill/main.vue'

export default {
    data() {
        return {
            is_initialized: false,
            is_fetching_data: false,
            is_processing: true,
            current_converter: {},
            converters_group_by_category: [],
            is_processing_by_core_waybills_pagination_false: false,
            error_message: "",
        }
    },
    computed: {
        current_store() {
            return this.$store.state.customer.core_waybills_module
        },
        current_operation() {
            return this.current_store.current_operation
        },
        core_waybills() {
            return this.current_store.core_waybills
        },
        tool_label() {
            return this.current_store.tool_label
        },
        is_show_filter() {
            return this.current_store.is_show_filter
        },
        filter() {
            return this.current_store.filter
        },
        current_staff() {
            return this.$store.state.customer.current_staff
        },
        token() {
            return localStorage.getItem("customer_authentication_token")
        },
    },
    created() {
    },
    mounted() {
        this.init()

        this.$bus.$off('init')
        this.$bus.$on('init', (value = false) => {
            this.init()
        })
    },
    beforeDestroy() {
        this.$bus.$off('init')
        this.current_store.current_page = 1
    },
    watch: {
        '$route'(to, from) {
            this.init(false)
        },
        'is_show_filter'(value) {
            if (!value) {
                this.$store.dispatch('customer/core_waybills_module/set_filter_init')
            }
        },

    },
    methods: {
        async init(is_first = true) {
            try {
                let dispatch_key_name = 'customer/core_waybills_module/'
                await new Promise(resolve => {
                    this.is_initialized = false
                    this.is_processing = true
                    this.error_message = ""
                    resolve()
                })
                if (is_first) await this.$store.dispatch(dispatch_key_name+'set_filter_init')
                await new Promise(resolve => {
                    this.filter.operation.number = this.$route.params.operation_number || null
                    resolve()
                })

                await this.$store.dispatch(dispatch_key_name+'handle_query_to_filter',{
                    query: this.$route.query
                })
                if (is_first) {
                     await this.$store.dispatch(dispatch_key_name+'handle_quick_filter_key')
                     await this.$store.dispatch(dispatch_key_name+'fetch_converters')
                     await new Promise(resolve => {
                         this.converters_group_by_category = _.groupBy(this.current_store.converters, "category") || {}
                         if (this.converters_group_by_category.export) {
                             this.current_converter = _.head(this.converters_group_by_category.export)
                         }
                         resolve()
                     })
                }

                await this.$store.dispatch(dispatch_key_name+'fetch_core_waybills')

                await new Promise(resolve => {
                    this.$noty.information(
                        this.$t("ui.page_titles.core_waybills") + ' ' +
                        this.$t('ui.general.initialize_complete')
                    , 300)
                    resolve()
                })
            } catch (e) {
                this.handle_error_message(e)
                this.is_initialized = true
            }

            await new Promise(resolve => {
                this.is_initialized = true
                this.is_processing = false
                resolve()
            })
        },
        export_core_waybills(converter_identity = null) {
            this.$store.dispatch('customer/core_waybills_module/export_core_waybills', {converter_identity: converter_identity})
        },
        async core_waybills_filter() {
            console.log('core_waybills_filter')
            try {
                await new Promise(resolve => {
                    this.$router.push({
                        name: this.$router.name,
                        query: this.$store.getters['customer/core_waybills_module/filter_to_query'],
                    })
                    resolve()
                })
            } catch (e) {
                console.log(e)
                this.handle_error_message(e)
            }
            await new Promise(resolve => {
                this.is_processing = false
                resolve()
            })
        },
        handle_error_message(err) {
            switch (err) {
                case 'fetch_core_waybills_no_anything_core_waybills':
                    // this.error_message = '查無運單'
                    this.error_message = this.$t('ui.notifications.error.no_data')
                    break

                case 'fetch_core_waybills_failure':
                    // this.error_message = '查詢運單失敗'
                    this.error_message = this.$t('ui.pages.core_waybills.errors.fetch_core_waybills_failure')
                    break

                case 'fetch_staffs_failure':
                    // this.error_message = '查詢員工失敗'
                    this.error_message = this.$t('ui.pages.core_waybills.errors.fetch_staffs_failure')
                    break

                case 'fetch_materials_failure':
                    // this.error_message = '查詢物料失敗'
                    this.error_message = this.$t('ui.pages.core_waybills.errors.fetch_materials_failure')
                    break

                case 'fetch_scan_action_prototypes_failure':
                    // this.error_message = '查詢曾經含有貨況失敗'
                    this.error_message = this.$t('ui.pages.core_waybills.errors.fetch_scan_action_prototypes_failure')
                    break

                case 'fetch_condition_status_prototypes_failure':
                    // this.error_message = '查詢貨況狀態失敗'
                    this.error_message = this.$t('ui.pages.core_waybills.errors.fetch_condition_status_prototypes_failure')
                    break

                case 'fetch_core_waybills_svg_error':
                    // this.error_message = '列印工具失敗'
                    this.error_message = this.$t('ui.pages.core_waybills.errors.fetch_core_waybills_svg_error')
                    break

                default:
                    // '例外錯誤，請聯絡系統商:' + err
                    this.error_message = this.$t('ui.notifications.error.exception_error_please_contact_the_system_supplier') + ": " + err
            }
        },
        async fetch_core_waybills_pagination_false() {
            try {
                this.is_processing_by_core_waybills_pagination_false = true
                await this.$store.dispatch('customer/core_waybills_module/fetch_core_waybills_pagination_false')
            } catch (err) {
                switch (err) {
                    case 'fetch_core_waybills_pagination_false nothing filter':
                        break
                    case 'core_waybills_label_type_different':
                        this.error_message = this.$t('ui.notifications.error.__name',{
                            name: this.$t('models.core_waybills') + " " + this.$t('ui.toolbox.core_waybill.errors.label_type_error')
                        })
                        break
                    case 'fetch_core_waybills_pagination_false_error':
                        this.error_message = this.$t('ui.notifications.error.find__name',{
                            name: this.$t('ui.general.print')
                        })
                        break
                    default:
                    this.error_message = this.$t('ui.notifications.error.exception_error_please_contact_the_system_supplier') + ':' + err
                }

                if (this.error_message) {
                    this.$noty.error(this.error_message)
                }
            } finally {
                this.is_processing_by_core_waybills_pagination_false = false
            }
        },
        async fetch_core_waybills_csv(type=null) {
            try {
                await this.$store.dispatch('customer/core_waybills_module/fetch_core_waybills_csv', {type:type})
            } catch (e) {
                console.log(e)
                this.handle_error_message(e)
            }
            await new Promise(resolve => {
                this.is_processing = false
                resolve()
            })
        },
        set_quick_filter_key(key, name) {
            try {
                this.current_store.quick_filter_key[key] = name
                if (key != "status") {
                    _.forEach(this.current_store.quick_filters[key], (value) => {
                        this.filter[value] = null
                    })
                }

            } catch (e) {
                console.log(e)
            }
        },
    },
    components: {
        CustomerDetailFilter,
        CoreWaybill,
        Paginator,
        CoreWaybillsLabelSvg
    }
}
</script>

<style scoped lang="scss">
    div#paginator {
        text-align: right;
    }
</style>
